import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const ProcessTranslationKeys = {
  processAccident: translationKey('process_Accident'),
  processChangeOrder: translationKey('process_ChangeOrder'),
  processDesignDocumentSubmittal: translationKey('process_DesignDocumentSubmittal'),
  processEnv: translationKey('process_Env'),
  processHS: translationKey('process_H&S'),
  processMaterialSubmittal: translationKey('process_MaterialSubmittal'),
  processMaterialSubmittalConstruction: translationKey('process_MaterialSubmittalConstruction'),
  processMaterialSubmittalElectrical: translationKey('process_MaterialSubmittalElectrical'),
  processMaterialSubmittalSanitary: translationKey('process_MaterialSubmittalSanitary'),
  processNote: translationKey('process_Note'),
  processQuality: translationKey('process_Quality'),
  processRequestForInformation: translationKey('process_RequestForInformation'),
  processTsk: translationKey('process_Tsk'),
} as const satisfies Record<string, TranslationKey>;
